export default {
  tabs: [
    {
      // 该功能的入口在评估师工作台 =》 [NC]收车审核详情页 =》 风险评估详情；
      // 价格运营平台 =》 定价列表/详情 =》 风险评估详情；
      // 门店定价-》定价详情-》风险评估详情；
      name: 'RiskDetail',
      path: '/riskDetail',
      component: () => import('./src/RiskDetail.vue'),
      meta: {
        title: '风险详情',
      },
    },
  ],
}
